export class MockedVitodens100WFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2020-02-23T02:17:28.989Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.temperature',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              fri: [
                {
                  end: '18:00',
                  mode: 'normal',
                  position: 0,
                  start: '07:30',
                },
              ],
              mon: [
                {
                  end: '06:00',
                  mode: 'normal',
                  position: 0,
                  start: '00:00',
                },
                {
                  end: '08:30',
                  mode: 'comfort',
                  position: 1,
                  start: '06:00',
                },
                {
                  end: '23:00',
                  mode: 'comfort',
                  position: 2,
                  start: '17:00',
                },
                {
                  end: '24:00',
                  mode: 'normal',
                  position: 3,
                  start: '23:00',
                },
              ],
              sat: [
                {
                  end: '06:00',
                  mode: 'normal',
                  position: 0,
                  start: '00:00',
                },
                {
                  end: '08:30',
                  mode: 'comfort',
                  position: 1,
                  start: '06:00',
                },
                {
                  end: '23:00',
                  mode: 'comfort',
                  position: 2,
                  start: '17:00',
                },
                {
                  end: '24:00',
                  mode: 'normal',
                  position: 3,
                  start: '23:00',
                },
              ],
              sun: [
                {
                  end: '06:00',
                  mode: 'normal',
                  position: 0,
                  start: '00:00',
                },
                {
                  end: '08:30',
                  mode: 'comfort',
                  position: 1,
                  start: '06:00',
                },
                {
                  end: '23:00',
                  mode: 'comfort',
                  position: 2,
                  start: '17:00',
                },
                {
                  end: '24:00',
                  mode: 'normal',
                  position: 3,
                  start: '23:00',
                },
              ],
              thu: [
                {
                  end: '18:00',
                  mode: 'normal',
                  position: 0,
                  start: '07:30',
                },
              ],
              tue: [
                {
                  end: '06:00',
                  mode: 'normal',
                  position: 0,
                  start: '00:00',
                },
                {
                  end: '08:30',
                  mode: 'comfort',
                  position: 1,
                  start: '06:00',
                },
                {
                  end: '23:00',
                  mode: 'comfort',
                  position: 2,
                  start: '17:00',
                },
                {
                  end: '24:00',
                  mode: 'normal',
                  position: 3,
                  start: '23:00',
                },
              ],
              wed: [
                {
                  end: '06:00',
                  mode: 'normal',
                  position: 0,
                  start: '00:00',
                },
                {
                  end: '08:30',
                  mode: 'comfort',
                  position: 1,
                  start: '06:00',
                },
                {
                  end: '23:00',
                  mode: 'comfort',
                  position: 2,
                  start: '17:00',
                },
                {
                  end: '24:00',
                  mode: 'normal',
                  position: 3,
                  start: '23:00',
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['comfort', 'normal'],
                  maxEntries: 20,
                  resolution: 5,
                  defaultMode: 'reduced',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2020-02-23T02:17:28.990Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0.6,
            unit: 'cubicMeter',
          },
          lastSevenDays: {
            type: 'number',
            value: 6,
            unit: 'cubicMeter',
          },
          currentMonth: {
            type: 'number',
            value: 4.1,
            unit: 'cubicMeter',
          },
          currentYear: {
            type: 'number',
            value: 222.3,
            unit: 'cubicMeter',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.summary.dhw',
        timestamp: '2023-07-05T06:04:35.452Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0.6,
            unit: 'cubicMeter',
          },
          lastSevenDays: {
            type: 'number',
            value: 6,
            unit: 'cubicMeter',
          },
          currentMonth: {
            type: 'number',
            value: 4.1,
            unit: 'cubicMeter',
          },
          currentYear: {
            type: 'number',
            value: 222.3,
            unit: 'cubicMeter',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.gas.consumption.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.gas.consumption.summary.heating',
        timestamp: '2023-07-05T06:04:35.452Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0.6,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 6,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 4.1,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 222.3,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.dhw',
        timestamp: '2023-07-05T06:04:35.452Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0.6,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 6,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 4.1,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 222.3,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.heating',
        timestamp: '2023-07-05T06:04:35.452Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              fri: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '14:00',
                },
              ],
              mon: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '06:00',
                },
              ],
              sat: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '06:00',
                },
              ],
              sun: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '06:00',
                },
              ],
              thu: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '06:00',
                },
              ],
              tue: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '06:00',
                },
              ],
              wed: [
                {
                  end: '23:00',
                  mode: 'on',
                  position: 0,
                  start: '06:00',
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 20,
                  resolution: 5,
                  defaultMode: 'off',
                  overlapAllowed: true,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2020-02-23T02:17:29.016Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device',
      },
      {
        properties: {
          status: {
            value: 'connected',
            type: 'string',
          },
          value: {
            value: 28.3984375,
            type: 'number',
            unit: 'celsius',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2020-02-26T06:41:32.883Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhw',
        timestamp: '2020-02-23T02:17:29.281Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhw',
      },
      {
        properties: {
          status: {
            value: 'notConnected',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2020-02-23T02:17:28.990Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndHeating',
        timestamp: '2020-02-23T02:17:28.990Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndHeating',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [
                {
                  timestamp: '2020-02-13T12:42:36.000Z',
                  errorCode: '18',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-04T14:28:22.000Z',
                  errorCode: 'f4',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-04T06:41:48.000Z',
                  errorCode: 'f4',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
              current: [
                {
                  timestamp: '2020-02-13T12:42:36.000Z',
                  errorCode: '18',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-04T14:28:22.000Z',
                  errorCode: 'f4',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
                {
                  timestamp: '2020-02-04T06:41:48.000Z',
                  errorCode: 'f4',
                  accessLevel: 'customer',
                  priority: 'criticalError',
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.history',
        timestamp: '2020-02-23T02:17:29.057Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.history',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating',
      },
      {
        properties: {
          value: {
            value: 50,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 30,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2020-02-23T02:17:29.014Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
      },
      {
        properties: {
          value: {
            value: 60,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2020-02-23T02:17:28.989Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2020-02-23T02:17:29.281Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
      },
      {
        properties: {
          status: {
            value: 'connected',
            type: 'string',
          },
          value: {
            value: 22.68,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.room',
        timestamp: '2020-02-26T06:17:25.168Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.room',
      },
      {
        properties: {
          min: {
            value: 20,
            type: 'number',
          },
          max: {
            value: 80,
            type: 'number',
          },
        },
        commands: {
          setMax: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.temperature.levels/setMax',
            name: 'setMax',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 21,
                  max: 80,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.temperature.levels',
        timestamp: '2020-02-23T02:17:29.282Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.temperature.levels',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 11.5,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.manual/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.manual/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.manual/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.manual',
        timestamp: '2020-02-23T02:17:28.991Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.manual',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2020-02-13T13:24:17.112Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 10,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reduced/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reduced',
        timestamp: '2020-02-25T16:00:00.886Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reduced',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2020-02-23T02:17:28.988Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 30,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfort/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfort',
        timestamp: '2020-02-26T05:00:00.745Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfort',
      },
      {
        properties: {
          enabled: {
            value: ['0'],
            type: 'array',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2020-02-23T02:17:29.013Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating',
      },
      {
        properties: {
          value: {
            value: 'dhwAndHeating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'dhw', 'dhwAndHeating'],
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2020-02-23T02:17:29.140Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
      },
      {
        properties: {
          value: {
            value: 'comfort',
            type: 'string',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2020-02-26T05:00:00.700Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 8,
            type: 'number',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normal/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 8,
                  max: 30,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normal',
        timestamp: '2020-02-26T05:00:00.745Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normal',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2020-02-23T02:17:28.991Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0',
        timestamp: '2020-02-26T05:01:18.318Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature',
      },
      {
        properties: {
          hours: {
            value: 285,
            type: 'number',
            unit: 'hours',
          },
          starts: {
            value: 1140,
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.burners.0.statistics',
        timestamp: '2020-02-26T05:47:50.617Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.burners.0.statistics',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/setName',
            name: 'setName',
            isExecutable: false,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2020-02-23T02:17:28.989Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes',
      },
      {
        properties: {
          status: {
            value: 'connected',
            type: 'string',
          },
          value: {
            value: 42.5,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.commonSupply',
        timestamp: '2020-02-26T06:42:48.278Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.commonSupply',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors',
      },
      {
        properties: {},
        commands: {},
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors',
        timestamp: '2020-02-23T02:17:28.890Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors',
      },
      {
        properties: {
          value: {
            value: 50,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 30,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature',
        timestamp: '2020-02-23T02:17:28.990Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature',
      },
      {
        properties: {
          shift: {
            type: 'number',
            value: 0,
          },
          slope: {
            type: 'number',
            value: 0.5,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.1,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2020-02-23T02:17:28.989Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
      },
      {
        isEnabled: true,
        isReady: true,
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.geofencing',
        deviceId: '0',
        timestamp: '2020-02-26T06:42:59.703Z',
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          status: {
            type: 'string',
            value: 'home',
          },
        },
        commands: {},
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.geofencing',
      },
    ];
  }
}
